import * as types from '../mutation-types';
import SessionService from '../../services/common/SessionService';
const state = {
    data: null,
    user: null,
    tenant: null,
    application: null
};
const getters = {
    data: (state) => { return state.data; },
    user: state => state.user,
    tenant: state => state.tenant,
    application: state => state.application
};

const mutations = {
    [types.SESSION_SET_SESSION](state, { session }) {
        state.data = session;
        state.user = session.user;
        state.tenant = session.tenant;
        state.application = session.application;
    }
};

const actions = {
    getSession(store) {
        SessionService.getSession().then(rs => {
            const session = rs;
            store.commit(types.SESSION_SET_SESSION, { session });
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
